import * as directives from './modules';
export default {
  install(Vue) {
    Object.keys(directives).forEach(k => Vue.directive(k, directives[k]));
  },
};